export default "__VITE_ASSET__CanjsxDW__"